var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.418 20.44l-5.668.81.81-5.668L28.134 1.006c1.342-1.341 3.517-1.341 4.859 0 1.341 1.342 1.341 3.517 0 4.859L18.418 20.44z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 11.115v20.597C34 32.975 32.985 34 31.733 34H2.267C1.015 34 0 32.975 0 31.712V6.538C0 5.275 1.015 4.25 2.267 4.25h15.866",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.093 9.35L4.25 9.35 4.25 29.75 28.9 29.75 28.9 16.15M4.25 16.15L8.5 16.15",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 25.5L11.05 25.5 11.05 29.75M22.1 25.5L28.9 25.5M24.65 20.4L28.9 20.4",
    transform: "translate(4 4)"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(-164 -140) translate(0 120) translate(164 20) translate(26 26)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5L9 13M5 9L13 9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.4465e637f57a40bbba66299d77bb2286.svg";
export { ForwardRef as ReactComponent };